/* eslint-disable react/jsx-props-no-spreading */
import App from 'next/app';
import React from 'react';
import { Provider } from 'react-redux';
import Head from 'next/head';
import withReduxStore from '../src/redux/stores/lib/with-redux-store';
import routerEvents from '../src/helpers/RouterEvents';
import { PgDataLayer, GtmHead } from '../src/components/Scripts';
import { getPgDataLayerConfig } from '../src/adapters/contentful.adapter';
import { getCurrentEnvironment } from '../src/helpers/environment';
import DOMPurify from 'isomorphic-dompurify';

class MyApp extends App {
    static async getInitialProps(appContext) {
        const appProps = await App.getInitialProps(appContext);
        
        try {
            const environment = getCurrentEnvironment();
            const pgdlConfig = await getPgDataLayerConfig(environment);
            
            return {
                ...appProps,
                pgdlConfig
            };
        } catch (error) {
            console.warn('Failed to fetch PG Data Layer config:', error);
            return {
                ...appProps,
                pgdlConfig: null
            };
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            routerEvents();
        }
        if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
            // React 19: use react-dom/client instead of react-dom
            const ReactDOM = require('react-dom/client');
            const axe = require('@axe-core/react');
            const config = {
                runOnly: {
                    type: 'tag',
                    values: ['wcag2aa', 'best-practice'],
                },
                resultTypes: ['violations'],
            };
            axe(React, ReactDOM, 1000, config);
        }
    }

    render() {
        const { Component, pageProps, reduxStore, pgdlConfig } = this.props;
        const sanitizedScript = DOMPurify.sanitize('window.PGdataLayer = window.PGdataLayer || {};window.PGdataLayer.user = window.PGdataLayer.user || {};window.PGdataLayer.GTM = window.PGdataLayer.GTM || {};var PGdataLayer = window.PGdataLayer;', {ALLOWED_TAGS: []});
            return (
                <>
                    <Head>
                        <script
                            id="pgdl-bootstrap"
                            type="text/javascript"
                            dangerouslySetInnerHTML={{
                                __html: sanitizedScript
                            }}
                        />
                        <PgDataLayer pgdlConfig={pgdlConfig} />
                        <GtmHead />
                    </Head>
                    <Provider store={reduxStore}>
                        <main role="main">
                            <Component {...pageProps} />
                        </main>
                    </Provider>
                    <footer role="contentinfo">
                    </footer>
                </>
        );
    }
}

export default withReduxStore(MyApp);